import { render, staticRenderFns } from "./App.vue?vue&type=template&id=d455ef0a&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/amomin/openlab/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VContent } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListGroup } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
import { VListTileAvatar } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VNavigationDrawer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarSideIcon } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VApp,VContent,VDivider,VIcon,VImg,VLayout,VList,VListGroup,VListTile,VListTileAction,VListTileAvatar,VListTileTitle,VNavigationDrawer,VToolbar,VToolbarSideIcon,VToolbarTitle})
